var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFix(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2002 3H21.0002V9H19.2002V5H15.6002V3H19.2002ZM4.80024 3H8.40024V5H4.80024V9H3.00024V3H4.80024ZM19.2002 19V15H21.0002V21H15.6002V19H19.2002ZM4.80024 19H8.40024V21H3.00024V15H4.80024V19Z",
    fill: "#CCCFD1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFix);
export default __webpack_public_path__ + "static/media/icon-fix.fac7d39de1f83dce1ba3239db0fa570d.svg";
export { ForwardRef as ReactComponent };